
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as index3MKxNGNCOnong2_45EIhkjleJz784Fq36z_sKeGqEad7AMeta } from "/vercel/path0/pages/[site_slug]/index.vue?macro=true";
import { default as searchNs51WXAtCfXFSQZKSRA8yaK0SWjoMy4tsz_45VQpmHEYgMeta } from "/vercel/path0/pages/[site_slug]/search.vue?macro=true";
import { default as indexjS3gW_45A1vlComrebcFNmPM2y0FI4mMmnly10Ibea5gUMeta } from "/vercel/path0/pages/[site_slug]/meetings/index.vue?macro=true";
import { default as indexRGXncBtG8kq13nES9AoQtdkT7QeKcSmvU8jK58Ys6y0Meta } from "/vercel/path0/pages/[site_slug]/policies/index.vue?macro=true";
import { default as _91slug_93Tnabv4d2Go79h4yOFx4Hut6yCC03PaYSha_bpl0hjWAMeta } from "/vercel/path0/pages/[site_slug]/policies/[slug].vue?macro=true";
import { default as subscriber_45settingsBFSkrffYKyidVCSNIQs_Y4O35VswMj_IIvbYneoaWa0Meta } from "/vercel/path0/pages/[site_slug]/subscriber-settings.vue?macro=true";
import { default as indexg8_456vQEhkr9XPdCG2bhOiYI0pu46IFECz8NnsKe9dsUMeta } from "/vercel/path0/pages/[site_slug]/meetings/[meeting_slug]/index.vue?macro=true";
import { default as agendafoGoRBmdU_20vXbfvVxyK3jByZUjRi2tNzXfQZX_CY0Meta } from "/vercel/path0/pages/[site_slug]/meetings/[meeting_slug]/agenda.vue?macro=true";
import { default as _91site_slug_93Cky3UCmiR2BrDjD_45YlRNRNVdwIQXYloJYuuS_45UWa5BwMeta } from "/vercel/path0/pages/[site_slug].vue?macro=true";
import { default as callbackh5BlNk_5NmpfVDD4b6dX2d7K12NPXA5wsmB_CKYJNNsMeta } from "/vercel/path0/pages/auth/callback.vue?macro=true";
import { default as indexXO_uHF2ocpyZ9aUUkeamZTxeA7jJOsmmb_45retCOev8QMeta } from "/vercel/path0/pages/[org_slug]/admin/index.vue?macro=true";
import { default as meetingsC_45GAA91MZN0drstqCAtivtuqNEA0JMOGGgNr5_4j_dAMeta } from "/vercel/path0/pages/[org_slug]/admin/meetings.vue?macro=true";
import { default as customize8bjFTVKDi_0MRFjoumJ87MPE0NUKRD9trsPUGvSyGaEMeta } from "/vercel/path0/pages/[org_slug]/admin/customize.vue?macro=true";
import { default as activity_45logMvt1OOt7sVhzJ3GKXOseIe47w9RwXM29lAD4m6iVoy8Meta } from "/vercel/path0/pages/[org_slug]/admin/activity-log.vue?macro=true";
import { default as _91id_93OOXOkV7Rm46O1RvJ76C6nb35gbhZVeCfjMpgjgI_45dg0Meta } from "/vercel/path0/pages/[org_slug]/admin/policies/[id].vue?macro=true";
import { default as indexb4ZBibYRmUGv4PQi1XSTVSKhjhvcn9GCdMQ9E646p5MMeta } from "/vercel/path0/pages/[org_slug]/admin/policies/index.vue?macro=true";
import { default as adminG0GtkBJPc12wjYfuiobiP5S1fiu3syrc27s6JCOhk5sMeta } from "/vercel/path0/pages/[org_slug]/admin.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: _91site_slug_93Cky3UCmiR2BrDjD_45YlRNRNVdwIQXYloJYuuS_45UWa5BwMeta?.name,
    path: "/:site_slug()",
    meta: { ...(_91site_slug_93Cky3UCmiR2BrDjD_45YlRNRNVdwIQXYloJYuuS_45UWa5BwMeta || {}), ...{"middleware":"public-site"} },
    component: () => import("/vercel/path0/pages/[site_slug].vue"),
    children: [
  {
    name: "site_slug",
    path: "",
    meta: index3MKxNGNCOnong2_45EIhkjleJz784Fq36z_sKeGqEad7AMeta || {},
    component: () => import("/vercel/path0/pages/[site_slug]/index.vue")
  },
  {
    name: "site_slug-search",
    path: "search",
    meta: searchNs51WXAtCfXFSQZKSRA8yaK0SWjoMy4tsz_45VQpmHEYgMeta || {},
    component: () => import("/vercel/path0/pages/[site_slug]/search.vue")
  },
  {
    name: "site_slug-meetings",
    path: "meetings",
    component: () => import("/vercel/path0/pages/[site_slug]/meetings/index.vue")
  },
  {
    name: "site_slug-policies",
    path: "policies",
    component: () => import("/vercel/path0/pages/[site_slug]/policies/index.vue")
  },
  {
    name: "site_slug-policies-slug",
    path: "policies/:slug()",
    component: () => import("/vercel/path0/pages/[site_slug]/policies/[slug].vue")
  },
  {
    name: "site_slug-subscriber-settings",
    path: "subscriber-settings",
    meta: subscriber_45settingsBFSkrffYKyidVCSNIQs_Y4O35VswMj_IIvbYneoaWa0Meta || {},
    component: () => import("/vercel/path0/pages/[site_slug]/subscriber-settings.vue")
  },
  {
    name: "site_slug-meetings-meeting_slug",
    path: "meetings/:meeting_slug()",
    component: () => import("/vercel/path0/pages/[site_slug]/meetings/[meeting_slug]/index.vue")
  },
  {
    name: "site_slug-meetings-meeting_slug-agenda",
    path: "meetings/:meeting_slug()/agenda",
    meta: agendafoGoRBmdU_20vXbfvVxyK3jByZUjRi2tNzXfQZX_CY0Meta || {},
    component: () => import("/vercel/path0/pages/[site_slug]/meetings/[meeting_slug]/agenda.vue")
  }
]
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: callbackh5BlNk_5NmpfVDD4b6dX2d7K12NPXA5wsmB_CKYJNNsMeta || {},
    component: () => import("/vercel/path0/pages/auth/callback.vue")
  },
  {
    name: adminG0GtkBJPc12wjYfuiobiP5S1fiu3syrc27s6JCOhk5sMeta?.name,
    path: "/:org_slug()/admin",
    meta: {"middleware":["auth","auth-org"]},
    component: () => import("/vercel/path0/pages/[org_slug]/admin.vue"),
    children: [
  {
    name: "org_slug-admin",
    path: "",
    meta: {"middleware":"auth"},
    component: () => import("/vercel/path0/pages/[org_slug]/admin/index.vue")
  },
  {
    name: "org_slug-admin-meetings",
    path: "meetings",
    meta: {"middleware":"auth"},
    component: () => import("/vercel/path0/pages/[org_slug]/admin/meetings.vue")
  },
  {
    name: "org_slug-admin-customize",
    path: "customize",
    meta: {"middleware":"auth"},
    component: () => import("/vercel/path0/pages/[org_slug]/admin/customize.vue")
  },
  {
    name: "org_slug-admin-activity-log",
    path: "activity-log",
    meta: {"middleware":"auth"},
    component: () => import("/vercel/path0/pages/[org_slug]/admin/activity-log.vue")
  },
  {
    name: "org_slug-admin-policies-id",
    path: "policies/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/vercel/path0/pages/[org_slug]/admin/policies/[id].vue")
  },
  {
    name: "org_slug-admin-policies",
    path: "policies",
    meta: {"middleware":"auth"},
    component: () => import("/vercel/path0/pages/[org_slug]/admin/policies/index.vue")
  }
]
  }
]